import script from "./imageList.vue?vue&type=script&setup=true&lang=ts"
export * from "./imageList.vue?vue&type=script&setup=true&lang=ts"

import "./imageList.vue?vue&type=style&index=0&id=4b5aaaae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5aaaae"]])

export default __exports__